import React from 'react';
import Layout, { LayoutProps } from '../Layout';
import { SettingsPageHeaderTitle } from './SettingsPageHeaderTitle';

export const SettingsLayout: React.FC<Partial<LayoutProps>> = ({
  children,
  ...others
}) => (
  <Layout
    title={<SettingsPageHeaderTitle />}
    showNavbarAuthActions={false}
    {...others}
  >
    {children}
  </Layout>
);
